/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import userReducer from './user/userSlice'
import organizationReducer from './organization/organizationSlice';
import authProviderReducer from './authProvider/authProviderSlice';
import roleReducer from './role/roleSlice';
import applicationReducer from './application/applicationSlice';
import deviceReducer from './device/deviceSlice';
import getchkdUserReducer from './getchkdUser/getchkdUserSlice';
import orgAppReducer from './organization/orgApp/orgAppSlice';
import orgUsersReducer from './organization/orgUsers/orgUsersSlice';
import applicationUsersReducer from './applicationUsers/applicationUsersSlice';
import orgApplicationDevicesReducer from './organization/orgApplicationDevices/orgApplicationDevicesSlice';
import orgAuthProviderReducer from './organization/orgAuthProvider/orgAuthProviderSlice';
import orgAppAuthProviderReducer from './organization/orgAppAuthProvider/orgAppAuthProviderSlice';
import initializedReducer from './initialized/initializedSlice'
import keycloakReducer from './keyCloak/keyCloakSlice';
import hashicorpReducer from './hashicorp/hashicorpSlice';
import mappingReducer from './mapping/mappingSlice';
import splunkReducer from './splunk/splunkSlice';
import accessReducer from './access/accessSlice';
import assetLocationReducer from './assetLocation/assetLocationSlice';
import personnelReducer from './personnel/personnelSlice';
import oktaReducer from './okta/oktaSlice';
import routerReducer from './router/routerSlice';


export const appReducer = {

  user: userReducer,
  organization: organizationReducer,
  authProvider: authProviderReducer,
  role: roleReducer,
  application: applicationReducer,
  device: deviceReducer,
  getchkdUser: getchkdUserReducer,
  orgApp: orgAppReducer,
  orgUsers: orgUsersReducer,
  applicationUsers: applicationUsersReducer,
  orgAuthProvider: orgAuthProviderReducer,
  orgAppAuthProvider: orgAppAuthProviderReducer,

  initialized: initializedReducer,
  orgApplicationDevices: orgApplicationDevicesReducer,

  keycloak: keycloakReducer,
  hashicorp: hashicorpReducer,
  mapping: mappingReducer,
  splunk: splunkReducer,
  access: accessReducer,
  assetLocation: assetLocationReducer,
  personnel: personnelReducer,
  okta: oktaReducer,
  router: routerReducer
} 